module.exports = [{"id":7334,"values":[{"id":29358,"description":"Control"},{"id":29359,"description":"Alt Control"},{"id":29360,"description":"Design Merch"},{"id":29361,"description":"Review merch"},{"id":29362,"description":"Force"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/trackedFeatures.json
// module id = 577
// module chunks = 0